import { __decorate } from "tslib";
import { Component, Vue } from "vue-facing-decorator";
import GcuDisplay from "@/components/gcu/GcuDisplay.vue";
let GcuConsultScreen = class GcuConsultScreen extends Vue {};
GcuConsultScreen = __decorate([Component({
  components: {
    GcuDisplay
  }
})], GcuConsultScreen);
export default GcuConsultScreen;